import "core-js/modules/es.array.push.js";
import { ref } from "vue";
// import { Icon } from "vant";
import kefu1 from "@/assets/images/kefu1.gif";
import kefuLeft from "@/assets/images/kefu-left.gif";
import arrowLeft from "@/assets/images/arrow-left.png";
import kefuRight from "@/assets/images/kefu-right.gif";
import arrowright from "@/assets/images/arrow-right.png";
import kefu from "@/assets/images/kefu.gif";
import dragBall from "@/components/dragBall/index";
export default {
  name: "BaseLayout",
  components: {
    dragBall
  },
  computed: {
    key() {
      return this.$route.path;
    }
  },
  mounted() {
    if (this.$route.query.id != undefined) {
      this.$i18n.locale = this.$route.query.id;
      this.tabLeftTitle = this.$tm(`message.tabLeft`) || [];
      this.tabLeftData = this.$tm(`message.tabLeft`)[0].data || [];
      this.tabRightData = this.$tm(`message.tabRight`) || [];
    }
  },
  data() {
    return {
      kefuRightImg: kefuRight,
      kefu1Img: kefu1,
      kefuLeftImg: kefuLeft,
      arrowLeftImg: arrowLeft,
      arrowrightImg: arrowright,
      value: "",
      kefuUrl: kefu,
      active: ref(0),
      tabLeftTitle: this.$tm(`message.tabLeft`) || [],
      tabLeftData: this.$tm(`message.tabLeft`)[0].data || [],
      tabRightData: this.$tm(`message.tabRight`) || []
    };
  },
  methods: {
    goCustomerService: function () {
      this.$router.push("/dist/customerServiceChat");
    },
    onSearch: function (val) {
      if ("" != val) {
        let tabLeft = JSON.parse(JSON.stringify(this.$tm(`message.tabLeft`))); //转换后更新不改变原数组
        let newArr = [];
        tabLeft.forEach(item => {
          item.data = item.data.filter(t => t.text.includes(val));
          if (item.data.length != 0) {
            item.data.forEach(t => {
              newArr.push(t);
            });
          }
        });
        this.tabLeftTitle = [];
        this.tabLeftData = newArr;
        if (newArr.length != 0) {
          this.active = ref(0);
          this.$router.push("/dist/lang/index");
        } else {
          let tabRight = this.$tm(`message.tabRight`);
          this.tabRightData = tabRight.filter(item => item.text.includes(val));
          if (this.tabRightData != 0) {
            this.active = ref(1);
          }
        }
      } else {
        this.tabLeftTitle = this.$tm(`message.tabLeft`);
        this.tabLeftData = this.$tm(`message.tabLeft`)[0].data;
        this.$router.push("/dist/lang/index");
      }
    },
    tabHandler: function (index) {
      console.log(`value->`, index);
      this.value = "";
      if (index == 0) {
        this.tabLeftTitle = this.$tm(`message.tabLeft`);
        this.tabLeftData = this.$tm(`message.tabLeft`)[0].data;
        this.$router.push("/dist/lang/index");
      } else {
        this.tabRightData = this.$tm(`message.tabRight`);
      }
    },
    toContant: function (value) {
      console.log(`value->`, value);
      this.$router.push({
        path: "/dist/playback",
        query: {
          value: value
        }
      });
      // window.location.href = value;
      // var page = window.open();
      // var html="<body style='background:black'> <div style='width:100%;margin:auto;'> <video controls width='100%' autoplay  webkit-playsinline playsinline src='"+value+ "'></video></div></body>"
      // page.document.write(html);
    }
  }
};